// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"746c21fe","453":"2567c08f"}[chunkId] + ".chunk.js";
};